<template>
    <modal name="photo-add-new-modal" :pivotY="0.2" :width="496" height="auto" >
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="hideModal('photo-add-new-modal')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="modal-title-big">
            Добавить фото
        </div>
        <ul>
            <li class="modal-list">
                JPG, JPEG, PNG форматы
            </li>
            <li class="modal-list">
                Не более 15 МБ в размере файла
            </li>
            <li class="modal-list">
                Высокое разрешение и в фокусе
            </li>
            <li class="modal-list">
                Беспрепятственный вид на дом
            </li>
            <li class="modal-list">
                В центре внимания - область интересов
            </li>
        </ul>
        <div class="dnd-container mb-40" @drop.prevent="receiveFiles" @dragover.prevent="dragover=true" @dragleave.prevent="dragover=false" @click="$refs.file.click()">
            <SVGPhotoDnDLoad :dragover="dragover"/>
        </div>
        <input type="file" id="fileInputModal" ref="file" v-on:change="handleFileUpload( $event)" accept=".jpg,.png" multiple hidden>
<!--        <div class="modal-button" v-on:click="submitAddPhoto">-->
<!--            Добавить-->
<!--        </div>-->
    </modal>
</template>

<script>
    import {modalMethods} from "../common";
    import SVGModalClose from "../SVG/SVGModalClose.vue";
    import SVGPhotoDnDLoad from "../SVG/SVGPhotoDnDLoad.vue";

    export default {
        name: "ModalAddPhoto",
        components: {SVGPhotoDnDLoad, SVGModalClose},
        mixins: [modalMethods],
        methods: {
            receiveFiles(event) {
              let droppedFiles = event.dataTransfer.files;
              this.$store.dispatch('active/SAVE_PHOTOS', droppedFiles);
              this.hideModal("photo-add-new-modal");
            },
            handleFileUpload(fileInput) {
              let files = fileInput.target.files;
              this.$store.dispatch('active/SAVE_PHOTOS', files);
              this.hideModal("photo-add-new-modal");
            },
            submitAddPhoto() {
                // this.$router.push({
                //     name: "editPhoto",
                //     params: { photoID:  1}})
                // this.$router.push('/configurator/photoEditor');
                this.hideModal("photo-add-new-modal");
            }
        },
        data () {
            return {
                dragover: false
            }
        }
    }
</script>

<style scoped>
    .mb-40 {
        margin-bottom: 40px;
    }

</style>
